export enum BookingFileOrigin {
    SCHOOL_FILE = "SCHOOL_FILE", 
    GLOBAL_FILE = "GLOBAL_FILE", 
    INDIVIDUAL_FILE = "INDIVIDUAL_FILE"
}
